import {
  tryGetLocalStorage,
  trySetLocalStorage,
  tryRemoveLocalStorage,
} from '@packages/utils/storage.ts'

interface Storage {
  get: (key: string) => string | null | Promise<string | null>
  remove: (key: string) => void | Promise<void>
  set: (key: string, data: any) => void | Promise<void>
}

const storages: {
  [key: string]: Storage
} = {
  localStorage: {
    set: (key: string, data: string) => trySetLocalStorage(key, data),
    get: (key: string) => tryGetLocalStorage(key),
    remove: (key: string) => tryRemoveLocalStorage(key),
  },
}

export default storages

export type { Storage }